module.exports = __webpack_public_path__ + "static/media/arrow-svgrepo-com (4).f83aa8a2.svg";